export const stateName = 'intellectualPropertyInfringement';